'use strict';

module.exports = require('./es6/crcjam').default;



//////////////////
// WEBPACK FOOTER
// ./~/crc/lib/crcjam.js
// module id = 648
// module chunks = 0